import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
  //const [educationSubOpen, setEducationSubOpen] = useState(false);
  const [educationDropdownOpen, setEducationDropdownOpen] = useState(false);
  const [coursesDropdownOpen, setCoursesDropdownOpen] = useState(false);

  
  /*************  ✨ Windsurf Command ⭐  *************/
  /**
   * Handles scroll event to shrink or expand the navbar
   * depending on the scroll position.
   */
  /*******  bfd331a5-af8e-4824-aa2c-d2e8abd68ca1  *******/ 

  useEffect(() => {
  let lastScrollY = window.scrollY;
  const navbar = document.querySelector(".navbar");

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    // Shrink navbar
    if (currentScrollY > 50) {
      navbar.classList.add("shrink");
    } else {
      navbar.classList.remove("shrink");
    }

    // Hide navbar on scroll down
    if (currentScrollY > lastScrollY && currentScrollY > 100) {
      navbar.classList.add("hide");
      navbar.classList.remove("show");
    } 
    // Show navbar when scrolling up
    else {
      navbar.classList.add("show");
      navbar.classList.remove("hide");
    }

    lastScrollY = currentScrollY;
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);


  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="navbar">
      <div className="logo">
        <NavLink to="/" onClick={() => setMenuOpen(false)}>
          <img src="/flytutor_logo.png" alt="FlyTutor Logo" />
        </NavLink>
      </div>

      {/* Hamburger Icon */}
      <div className="menu-icon" onClick={toggleMenu}>
        {menuOpen ? "✖" : "☰"}
      </div>

      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li>
          <NavLink
            to="/"
            end
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            Home
          </NavLink>
        </li>

        {/* About with Submenu (Side Panel) */}
        <li
          className="dropdown"
          onMouseEnter={() => setAboutDropdownOpen(true)}
          onMouseLeave={() => {
            setAboutDropdownOpen(false);
          }}
        >
          <span className="dropdown-toggle">About ▾</span>

          {aboutDropdownOpen && (
            <ul className="dropdown-menu">
              <li>
                <NavLink to="/about" onClick={() => setMenuOpen(false)}>
                  About Us
                </NavLink>
              </li>

              <li>
                <NavLink to="/gallery" onClick={() => setMenuOpen(false)}>
                  Gallery
                </NavLink>
              </li>

              <li>
                <NavLink to="/careers" onClick={() => setMenuOpen(false)}>
                  Careers
                </NavLink>
              </li>

              <li>
                <NavLink to="/franchise" onClick={() => setMenuOpen(false)}>
                  Franchise
                </NavLink>
              </li>

              {/* Side Panel Submenu */}
              {/* <li
                className="dropdown-sub"
                onMouseEnter={() => setEducationSubOpen(true)}
                onMouseLeave={() => setEducationSubOpen(false)}
              >
                <span className="dropdown-toggle">Education Purpose ▸</span>

                {educationSubOpen && (
                  <ul className="dropdown-submenu">
                    <li>
                      <NavLink
                        to="/education"
                        onClick={() => setMenuOpen(false)}
                      >
                        Industrial Visit & Training
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/quiz" onClick={() => setMenuOpen(false)}>
                        Quiz
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>  */}
            </ul>
          )}
        </li>

        {/* Courses with Dropdown */}
        <li
          className="dropdown"
          onMouseEnter={() => setCoursesDropdownOpen(true)}
          onMouseLeave={() => setCoursesDropdownOpen(false)}
        >
          <span className="dropdown-toggle">Courses ▾</span>
          {coursesDropdownOpen && (
            <ul className="dropdown-menu">
              <li>
                <NavLink
                  to="/course"
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                >
                  DGCA Authorized Certificate
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/certificate"
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                >
                  Add On Courses
                </NavLink>
              </li>
            </ul>
          )}
        </li>

        {/* Sales */}
        <li>
          <NavLink
            to="/sales"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            Sales
          </NavLink>
        </li>

        {/* Educational Purposes */}
        <li
          className="dropdown"
          onMouseEnter={() => setEducationDropdownOpen(true)}
          onMouseLeave={() => setEducationDropdownOpen(false)}
        >
          <span className="dropdown-toggle">Educational Purposes ▾</span>
          {educationDropdownOpen && (
            <ul className="dropdown-menu">
              <li>
                <NavLink
                  to="/education"
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                >
                  Industrial Visit & Training
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/quiz"
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                >
                  Contest
                </NavLink>
              </li>
            </ul>
          )}
        </li>
        

        <li>
          <NavLink
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            Contact
          </NavLink>
        </li>
      </ul>
    </header>
  );
}

export default Navbar;
